import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-avatar-selector',
    templateUrl: './avatar-selector.component.html',
    styleUrls: ['./avatar-selector.component.scss'],
    standalone: false
})
export class AvatarSelectorComponent {

    @Input()
    checked: boolean;

    /** Source url of avatar image */
    @Input()
    src: string;

    /** Source Key of avatar image */
    @Input()
    number: string;

    /** Radio button group */
    @Input()
    name: string;

    @Output()
    selectionChange = new EventEmitter<any>();

    constructor() {
    }

    get avatarTitle(): string {
        return $localize`:@@input.avatar.variant:Avatar Variant #` + this.number;
    }

    onChange($event: Event) {
        this.selectionChange.emit($event);
    }
}
